import React from "react";
import axios from "axios";
import constant from "../../constant";
import { ProgressBar } from "../../components/LoadingComp";
import "./style.scss";

export default class Step2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      video_src: "",
      is_video: false,
      visibility: false,
      videoPath: `${constant.s3BucketPath}list_images/`,
      errors: {}
    };
  }

  componentDidMount() {
    let _this = this;
    let { spaceId, listing } = this.props;

    if (listing === "edit") {
      axios
        .get(`${constant.phpHost}action/listing.php`, {
          params: {
            todo: "get_listing_video",
            space_id: spaceId
          }
        })
        .then(res => {
          if (res.data) {
            localStorage.setItem(spaceId + "_video", res.data);

            _this.setState({
              video_src: `${_this.state.videoPath}${spaceId}/video/${res.data}`,
              visibility: true
            });
          }
        });
    }

    this.handleRefreshVideo();
  }

  handleRefreshVideo = () => {
    let { spaceId, listing } = this.props;
    let get_video = localStorage.getItem(spaceId + "_video");
    if (get_video) {
      let video_path = `${constant.phpHost}/uploads/Jqimg/temp/${spaceId}/video/${get_video}`;
      if (listing === "edit") {
        video_path = `${this.state.videoPath}${spaceId}/video/${get_video}`;
      }
      this.setState({
        video_src: video_path,
        visibility: true
      });
    }
  };

  handleVideoChange = e => {
    let _this = this;
    let errors = {};
    let file = e.target.files[0];
    let video_size = file.size;
    let video_name = file.name;
    let parts = video_name.split(".");
    let ext = parts[parts.length - 1];
    let max_size = 104857600; // 100MB
    let visibility = true;

    let video = document.querySelector("#video");
    video.load();

    if ((ext === "mp4" || ext === "mov") && video_size <= max_size) {
      video.addEventListener("loadedmetadata", () => {
        _this.validate_video(video.videoWidth, file, max_size);
      });
    } else {
      visibility = false;
      errors["video"] =
        "Please make sure your file is in MP4 or MOV format and less than 100 MB.";
    }

    this.setState({
      errors,
      visibility,
      video_src: URL.createObjectURL(file)
    });
  };

  validate_video = (width, file, max_size) => {
    let errors = {};
    let visibility = false;

    if (width < 720 && file.size > max_size) {
      errors["video"] =
        "Please make sure your resolution must be greater than 720p and file size should be less than 100 MB.";
    } else if (width > 720 && file.size > max_size) {
      errors["video"] =
        "Please make sure your file size should be less than 100 MB.";
    } else if (width < 720 && file.size < max_size) {
      errors["video"] =
        "Please make sure your resolution must be greater than 720p.";
    } else {
      visibility = true;
      this.save_video(file);
    }

    this.setState({ errors, visibility });
  };

  save_video = video => {
    let _this = this;
    let { spaceId, isLogin, listing } = this.props;
    let errors = {};

    this.setState({
      visibility: false,
      is_video: true,
      progress: 0,
      errors
    });

    let formData = new FormData();
    formData.append("todo", "save_video");
    formData.append("video", video);
    formData.append("space_id", spaceId);
    formData.append("is_login", isLogin);
    formData.append("listing", listing);

    axios
      .post(`${constant.phpHost}action/listing.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: progress => {
          _this.setState({
            progress: Math.round((progress.loaded * 100) / progress.total)
          });
        }
      })
      .then(res => {
        localStorage.setItem(spaceId + "_video", res.data);
        _this.setState({
          visibility: true,
          is_video: false,
          progress: 0
        });
      });
  };

  delete_video = () => {
    let { spaceId, listing } = this.props;

    var formData = new FormData();
    formData.append("todo", "delete_video");
    formData.append("space_id", spaceId);
    formData.append("listing", listing);

    axios.post(`${constant.phpHost}action/listing.php`, formData).then(res => {
      localStorage.removeItem(spaceId + "_video");
      this.setState({
        visibility: false,
        is_video: false,
        progress: 0,
        errors: {}
      });
    });
  };

  handleClick = () => {
    this.refs.fileUploader.click();
  };

  // Next Steps
  buttonStep = step => {
    let { is_video } = this.state;

    if (!is_video) {
      if (step === "prev") {
        this.props.stepButton(1);
      } else {
        this.props.stepButton(3);
      }
    }
  };

  render() {
    let { errors, video_src, is_video, visibility, progress } = this.state;

    function chk_errors(field) {
      return errors && errors[field] ? (
        <span
          style={{
            color: "red",
            paddingLeft: "50px",
            display: "block",
            marginBottom: "50px",
            textAlign: "center"
          }}
        >
          {errors[field]}
        </span>
      ) : null;
    }
    return (
      <div>
        <h3 className="heading"> Upload Videos </h3>

        <div className={`video_upload ${!visibility ? "video_upload_s" : ""}`}>
          <video
            id="video"
            poster="/assets/images/video_poster.jpg"
            disablePictureInPicture
            controlsList="nodownload"
            controls
            onClick={({ target: video }) =>
              video.paused ? video.pause() : video.play()
            }
            style={
              visibility
                ? { visibility: "visible", height: "unset" }
                : { visibility: "hidden", height: 0 }
            }
          >
            <source src={video_src} />
          </video>
        </div>

        {is_video ? (
          <ProgressBar
            progress={progress}
            customStyle={{
              padding: "0 50px",
              margin: "15px auto",
              width: "70%"
            }}
          />
        ) : null}

        {visibility ? (
          <div className="delete_action">
            You have to change the video?
            <button onClick={this.delete_video}>
              <i className="fa fa-trash" />
            </button>
          </div>
        ) : (
          <div className="image_block" onClick={this.handleClick}>
            <input
              ref="fileUploader"
              type="file"
              name="video"
              onChange={this.handleVideoChange}
              accept=".mp4,.mov"
            />
            <img
              src="\assets\images\upld_pic.jpg"
              onClick={this.handleClick}
              alt="pic"
            />
            <div>
              <p className="color_red_b">Upload Videos</p>
              <p>
                <i className="fa fa-warning" /> MP4 or MOV format and less than
                100 MB
              </p>
              <p>Skip and continue next step</p>
            </div>
          </div>
        )}

        {chk_errors("video")}

        <div className="button">
          <div className="prev_button">
            <button onClick={() => this.buttonStep("prev")}>
              <span>&#x276E;</span>
              {window.innerWidth < 767 ? "PREV" : "PREVIOUS STEP"}
            </button>
          </div>
          <div className="next_button">
            <button onClick={() => this.buttonStep("next")}>
              {window.innerWidth < 767 ? "NEXT" : "NEXT STEP"}
              <span>&#x276F;</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
